import { RECEIVE_RESERVATION } from '../constants';
import { receiveBarbers } from '../barbers/actions';
import { receiveShops } from '../shops/actions';
import { receiveServices } from '../services/actions';

const populateReservationFromAppointment = store => next => (action) => {
  if (action.type === RECEIVE_RESERVATION) {
    store.dispatch(receiveBarbers([action.payload.barber]));
    store.dispatch(receiveShops([action.payload.shop]));
    const services = action.payload.appointment_service.map(as => as.service);
    store.dispatch(receiveServices(services));
  }
  return next(action);
};

export default populateReservationFromAppointment;



// WEBPACK FOOTER //
// ./src/app/middlewares/populateReservationFromAppointment.js